var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParagraphBody',{attrs:{"data-test-id":"ResourceError__errorText"}},[_c('Icon',{class:_vm.$style.errorIcon,attrs:{"icon":"error","inline":""}}),_vm._v(" "+_vm._s(_vm.$options.errorText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }